import { render, staticRenderFns } from "./UserSexTrend.vue?vue&type=template&id=05d4c781&scoped=true&"
import script from "./UserSexTrend.vue?vue&type=script&lang=js&"
export * from "./UserSexTrend.vue?vue&type=script&lang=js&"
import style0 from "./UserSexTrend.vue?vue&type=style&index=0&id=05d4c781&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d4c781",
  null
  
)

component.options.__file = "UserSexTrend.vue"
export default component.exports